import { useMutation, useQueryClient } from '@tanstack/react-query'
import { client } from '../client'
import { queryKeys } from '../keys'
import type { components } from '@/lib/generated/api-types'

type SnowHuntParams = components['schemas']['SnowHuntParams']

// Start a snow hunt
export function useStartSnowHunt() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ params }: { params: SnowHuntParams }) => {
      const { data, error } = await client.POST('/api/v1/snow-hunt', {
        body: params,
      })
      if (error) throw error
      return data
    },
    onSuccess: (_data, { params }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.snowHunt.current(params.primary_account),
      })
    },
  })
}

// Stop a snow hunt
export function useStopSnowHunt() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ primaryAccount }: { primaryAccount: string }) => {
      const { error } = await client.DELETE('/api/v1/snow-hunt/current', {
        params: { query: { primary_account: primaryAccount } },
      })
      if (error) throw error
    },
    onSuccess: (_data, { primaryAccount }) => {
      queryClient.removeQueries({
        queryKey: queryKeys.snowHunt.current(primaryAccount),
      })
    },
  })
}
